/* eslint-disable arrow-body-style */
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';

import commonStyles from '../../Common/commonStyles';

import ComponentCard from './ComponentCard';

const styles = StyleSheet.create({
  productsPageContainer: {
    marginHorizontal: commonStyles.marginHorizontal,
  },
  productsPageTitle: {
    ...commonStyles.fontM,
    fontWeight: 'bold',
  },
});

function ProductsPage({ specification, components, sizes, t, productLabels }) {
  return (
    <View style={styles.productsPageContainer} break>
      {components.length > 0 ? (
        <>
          {components.map((component) => (
            <ComponentCard
              key={component.id}
              specification={specification}
              component={component}
              sizes={sizes}
              t={t}
              productLabels={productLabels}
            />
          ))}
        </>
      ) : (
        <Text>{t('no_added_components')}</Text>
      )}
    </View>
  );
}

export default withTranslation('specification')(ProductsPage);
